var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSbSolomonIslands(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 45,
    viewBox: "0 0 60 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_188_22992)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60 44.5781L-26.7832 0H60V44.5781Z",
    fill: "#0000D6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-30 0L57.6094 45H-30V0Z",
    fill: "#006000"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-30 0H-25.1748L60 42.6621V45H55.1748L-30 2.42578V0Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.7246 0.799805L52.6875 3.83203H49.3037L52.0371 5.68652L50.9912 8.70996L53.7246 6.85547L56.458 8.71875L55.4121 5.69531L58.1455 3.82324H54.7705L53.7246 0.799805ZM36.9287 0.799805L35.8828 3.83203H32.499L35.2412 5.69531L34.1865 8.71875L36.9375 6.85547L39.6621 8.72754L38.6162 5.7041L41.3584 3.83203H37.9746L36.9287 0.799805ZM36.9287 13.5L35.8828 16.5322H32.499L35.2412 18.3955L34.1865 21.4189L36.9287 19.5469L39.6533 21.4189L38.6074 18.3955L41.3496 16.5234H37.9658L36.9287 13.5ZM45.2783 7.22461L44.2324 10.248H40.8574L43.582 12.1201L42.5449 15.1436L45.2695 13.2715L48.0117 15.1436L46.957 12.1201L49.6992 10.248H46.3154L45.2783 7.22461ZM53.7246 13.5L52.6875 16.5322H49.3037L52.0371 18.3955L50.9912 21.4189L53.7246 19.5469L56.458 21.4189L55.4033 18.3955L58.1543 16.5234H54.7793L53.7246 13.5Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_188_22992"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 45,
    fill: "white",
    transform: "matrix(-1 0 0 1 60 0)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSbSolomonIslands);
export default __webpack_public_path__ + "static/media/sb Solomon Islands.60092b88b87b7b08f1cb3b2ee35705f7.svg";
export { ForwardRef as ReactComponent };